import { API_CALL } from '../../../../middleware/api';
import {
  GET_ADMIN_USERS,
  GET_ADMIN_USER_DETAILS,
  GET_ADMIN_USER_FORM_BUNDLE,
  CREATE_ADMIN_USER,
  EDIT_ADMIN_USER,
  GET_ADMIN_ROLES,
  GET_ADMIN_ROLE_DETAILS,
  GET_ADMIN_ROLE_FORM_BUNDLE,
  CREATE_ADMIN_ROLE,
  EDIT_ADMIN_ROLE,
  GET_ADMIN_ARCHETYPES,
  GET_ADMIN_ORGANIZATIONS,
  GET_ADMIN_ORGANIZATION_DETAILS,
  GET_ADMIN_ORGANIZATION_FORM_BUNDLE,
  CREATE_ADMIN_ORGANIZATION,
  EDIT_ADMIN_ORGANIZATION,
  GET_ADMIN_ORG_GROUPS,
  GET_ADMIN_ORG_GROUP_DETAILS,
  CREATE_ADMIN_ORG_GROUP,
  EDIT_ADMIN_ORG_GROUP,
  GET_ADMIN_ORG_GROUP_ORGANIZATIONS,
  ADD_ADMIN_ORG_GROUP_ORGANIZATION,
  REMOVE_ADMIN_ORG_GROUP_ORGANIZATION,
  SEARCH_ADMIN_USERS,
  SEARCH_ADMIN_ORGANIZATIONS,
  SEARCH_MAINTAINER_CANDIDATES,
} from './constants';

export const actions = {
  getUsers: (params) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/users',
      params,
      latest: true,
    },
    type: GET_ADMIN_USERS,
  }),

  getUserDetails: (userId) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/admin/users/${userId}`,
    },
    type: GET_ADMIN_USER_DETAILS,
  }),

  getUserFormBundle: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/users/form-bundle',
    },
    type: GET_ADMIN_USER_FORM_BUNDLE,
  }),

  createUser: (data) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/v1/superadmin/admin/users',
      data,
    },
    type: CREATE_ADMIN_USER,
  }),

  editUser: (userId, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/admin/users/${userId}`,
      data,
    },
    type: EDIT_ADMIN_USER,
  }),

  sendPasswordReset: (userId, method = 'email') => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/v1/superadmin/admin/users/${userId}/send-password-reset`,
      data: { method },
    },
    type: 'SEND_PASSWORD_RESET',
  }),

  setUserPassword: (userId, password) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/v1/superadmin/admin/users/${userId}/set-password`,
      data: { password },
    },
    type: 'SET_USER_PASSWORD',
  }),

  addUserRole: (userId, roleUuid) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `/portal/auth/user/${userId}/roles`,
      data: { role_uuid: roleUuid },
    },
    type: 'ADD_USER_ROLE',
  }),

  addUserNativeRole: (userId, roleUuid) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `/portal/auth/user/${userId}/roles/native`,
      data: { role: { role_uuid: roleUuid } },
    },
    type: 'ADD_USER_NATIVE_ROLE',
  }),

  removeUserRole: (userId, roleUuid) => ({
    [API_CALL]: {
      method: 'DELETE',
      endpoint: `/portal/auth/user/${userId}/roles/${roleUuid}`,
    },
    type: 'REMOVE_USER_ROLE',
  }),

  getRoles: (params) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/roles',
      params,
      latest: true,
    },
    type: GET_ADMIN_ROLES,
  }),

  getRoleDetails: (roleId) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/admin/roles/${roleId}`,
    },
    type: GET_ADMIN_ROLE_DETAILS,
  }),

  getRoleFormBundle: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/roles/form-bundle',
    },
    type: GET_ADMIN_ROLE_FORM_BUNDLE,
  }),

  createRole: (data) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/v1/superadmin/admin/roles',
      data,
    },
    type: CREATE_ADMIN_ROLE,
  }),

  editRole: (roleId, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/admin/roles/${roleId}`,
      data,
    },
    type: EDIT_ADMIN_ROLE,
  }),

  getArchetypes: (params) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/archetypes',
      params,
    },
    type: GET_ADMIN_ARCHETYPES,
  }),

  getOrganizations: (params) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/organizations',
      params,
      latest: true,
    },
    type: GET_ADMIN_ORGANIZATIONS,
  }),

  getOrganizationDetails: (orgId) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/admin/organizations/${orgId}`,
    },
    type: GET_ADMIN_ORGANIZATION_DETAILS,
  }),

  getOrganizationFormBundle: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/organizations/form-bundle',
    },
    type: GET_ADMIN_ORGANIZATION_FORM_BUNDLE,
  }),

  createOrganization: (data) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/v1/superadmin/admin/organizations',
      data,
    },
    type: CREATE_ADMIN_ORGANIZATION,
  }),

  editOrganization: (orgId, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/admin/organizations/${orgId}`,
      data,
    },
    type: EDIT_ADMIN_ORGANIZATION,
  }),

  // `latest` only for the org groups table: dropdowns load the same list in parallel.
  getOrgGroups: (params, { latest = false } = {}) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/org-groups',
      params,
      latest,
    },
    type: GET_ADMIN_ORG_GROUPS,
  }),

  getOrgGroupDetails: (orgGroupId) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/admin/org-groups/${orgGroupId}`,
    },
    type: GET_ADMIN_ORG_GROUP_DETAILS,
  }),

  createOrgGroup: (data) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/v1/superadmin/admin/org-groups',
      data,
    },
    type: CREATE_ADMIN_ORG_GROUP,
  }),

  editOrgGroup: (orgGroupId, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/admin/org-groups/${orgGroupId}`,
      data,
    },
    type: EDIT_ADMIN_ORG_GROUP,
  }),

  getOrgGroupOrganizations: (orgGroupId) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/admin/org-groups/${orgGroupId}/organizations`,
    },
    type: GET_ADMIN_ORG_GROUP_ORGANIZATIONS,
  }),

  addOrganizationToOrgGroup: (orgGroupId, organizationId) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/v1/superadmin/admin/org-groups/${orgGroupId}/organizations`,
      data: { organization_id: organizationId },
    },
    type: ADD_ADMIN_ORG_GROUP_ORGANIZATION,
  }),

  removeOrganizationFromOrgGroup: (orgGroupId, organizationId) => ({
    [API_CALL]: {
      method: 'DELETE',
      endpoint: `portal/v1/superadmin/admin/org-groups/${orgGroupId}/organizations/${organizationId}`,
    },
    type: REMOVE_ADMIN_ORG_GROUP_ORGANIZATION,
  }),

  searchUsers: (searchTerm) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/users',
      params: { search: searchTerm, limit: 20 },
    },
    type: SEARCH_ADMIN_USERS,
  }),

  searchOrganizations: (searchTerm) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/organizations',
      params: { search: searchTerm, limit: 20 },
    },
    type: SEARCH_ADMIN_ORGANIZATIONS,
  }),

  searchMaintainerCandidates: (orgGroupId, searchTerm) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/admin/org-groups/${orgGroupId}/maintainer-candidates`,
      params: { search: searchTerm },
    },
    type: SEARCH_MAINTAINER_CANDIDATES,
  }),
};
